import { isNativeModulesDisabled } from "@memorang/helpers/common";
import { isWeb } from "@memorang/helpers/platform";

type OneSignalClient = {
	initialize: (appId: string) => void;
	Notifications: {
		requestPermission: (
			fallbackToSettings: boolean,
		) => Promise<boolean> | undefined;
	};
	User: {
		addEmail: (email: string) => void;
	};
};

const loadOneSignal = (): OneSignalClient | null => {
	if (isWeb || isNativeModulesDisabled()) {
		return null;
	}

	try {
		const module = require("react-native-onesignal") as {
			OneSignal?: OneSignalClient;
		};

		return module.OneSignal ?? null;
	} catch (error) {
		if ((globalThis as { __DEV__?: boolean }).__DEV__) {
			console.warn(
				"[onesignal] Native module unavailable, skipping push initialization.",
				error,
			);
		}
		return null;
	}
};

export const OneSignal = loadOneSignal();
